export const formatSubject = (raw?: string) => {
  if (!raw) return '';
  const cleared = raw?.replace(/^\d+-/, '').replace(/-/g, ' ');

  return cleared?.charAt(0).toUpperCase() + cleared?.slice(1);
};
